import translations from "../../translations/resources/en-GB.json";
var OVERVIEW_PAGE = {
    MAPS_API_LIST: "https://developer.here.com/documentation/indoor-map/user_guide/topics/indoor-jsapi.html",
    HERE_HSDK_LINK: "https://developer.here.com/documentation/indoor-map/user_guide/topics/indoor-hsdk.html",
    HERE_DATA_API_LINK: "https://developer.here.com/documentation/indoor-map/user_guide/topics/indoor-data-api.html",
    CREATE_CRED_LINK: "https://platform.here.com/admin/apps",
    SEE_MORE_LINK: "https://developer.here.com/documentation",
    GET_STARTED_LINK: "https://developer.here.com/documentation/indoor-map/user_guide/index.html",
    TUTORIALS_LINK: "https://developer.here.com/documentation/indoor-map/user_guide/topics/concepts.html",
    CODE_EXAMPLES_LINK: "https://developer.here.com/documentation/examples/maps-js/data/indoor-map",
};
var JSMAP = {
    ICONS: "https://sab.blob.data.api.platform.sit.here.com/blobstore/v2/catalogs/hrn:here:data::olp-here-indoor:indoormap-global-metadata/layers/icons/keys/iterate",
    THEME: "",
    //Incase the apikey does not work, check for the apikey with the below info
    //AppId: jTrmnm32nKXQctkrogyh, Name: Indoor Project Management App, Prod - olp-here-indoor realm
    APIKEY: "OlIM46PjJeX3u-wL_zwaRIRHuLoJWbKDUS2XbGWraU0",
};
var INDOOR_MAP = {
    MAP_PER_PAGE: 15,
    OVERVIEW_MAP_PER_PAGE: 3,
    DEFAULT_SNAPSHOT_TIME: "2286-11-20T17:46:39.999Z",
    SEARCH_FIELD: [
        "id",
        "name",
        "address.city",
        "address.country",
        "address.street",
        "address.postalCode",
        "address.label",
    ],
    SEARCH_FIELD_MAPCOLLECTION: ["mapName", "mapcity", "mapid"],
    AUTHORIZED_ROLES: ["OrgAdmin"],
    ALLOWED_REALMS: [
        "olp-here-indoor",
        "org651595200",
        "org16291096",
        "olp-here-ci-mp-p",
    ],
    DOWNLOAD_COLLECTION_FILE_NAME: "Map_collection",
    DOWNLOAD_CHECKIN_REPORT_FILE_NAME: "Check-in_Report",
    RELOAD_ICONS_RULES_URL: "/snapshots/2286-11-20T17:46:39.999Z?reloadAssets=icons%2Cimrules",
};
var GEOJSON_GEOMETRY_TYPE = {
    POINT: "Point",
    LINE_STRING: "LineString",
    POLYGON: "Polygon",
    MULTI_POINT: "MultiPoint",
    MULTI_LINESTRING: "MultiLineString",
    MULTI_POLYGON: "MultiPolygon",
    GEOMETRY_COLLECTION: "GeometryCollection",
};
var MapFields;
(function (MapFields) {
    MapFields["indoorMapName"] = "indoorMapName";
    MapFields["indoorMapOrganizationId"] = "indoorMapOrganizationId";
    MapFields["indoorMapId"] = "indoorMapId";
    MapFields["indoorMapType"] = "indoorMapType";
    MapFields["addressline1"] = "addressline1";
    MapFields["addressline2"] = "addressline2";
    MapFields["city"] = "city";
    MapFields["postCode"] = "postCode";
    MapFields["countryCode"] = "countryCode";
    MapFields["country"] = "country";
    MapFields["internalAddress"] = "internalAddress";
    MapFields["latitude"] = "latitude";
    MapFields["longitude"] = "longitude";
    MapFields["description"] = "description";
})(MapFields || (MapFields = {}));
export var PORTAL_TABS = {
    INTERNAL_TOOLS: "internalTools",
    INDOOR_MAP: "indoorMap",
};
export var MapKeys;
(function (MapKeys) {
    MapKeys["READY"] = "READY";
    MapKeys["IN_CREATION"] = "IN_CREATION";
    MapKeys["PENDING_UPDATE"] = "PENDING_UPDATE";
    MapKeys["CHECKED_IN"] = "CHECKED_IN";
    MapKeys["CHECKED_OUT"] = "CHECKED_OUT";
})(MapKeys || (MapKeys = {}));
export var HeaderTabKeys;
(function (HeaderTabKeys) {
    HeaderTabKeys["OVERVIEW"] = "OVERVIEW";
    HeaderTabKeys["INTERNAL_TOOLS"] = "INTERNAL_TOOLS";
    HeaderTabKeys["YOUR_INDOOR_MAP"] = "YOUR_INDOOR_MAP";
    HeaderTabKeys["DOCUMENTATIONS"] = "DOCUMENTATIONS";
})(HeaderTabKeys || (HeaderTabKeys = {}));
export var MAP_STATUS = {
    READY: {
        LABEL: translations.data["venonboard.indoorMaps.chipStatusReady"],
        VALUE: translations.data["venonboard.indoorMaps.chipStatusReady"],
    },
    IN_CREATION: {
        LABEL: translations.data["venonboard.indoorMaps.chipStatusInCreation"],
        VALUE: translations.data["venonboard.indoorMaps.chipStatusInCreation"],
    },
    PENDING_UPDATE: {
        LABEL: translations.data["venonboard.indoorMaps.chipStatusPendingUpdate"],
        VALUE: translations.data["venonboard.indoorMaps.chipStatusPendingUpdate"],
    },
    CHECKED_IN: {
        LABEL: translations.data["venonboard.internalTools.chipStatusCheckin"],
        VALUE: translations.data["venonboard.internalTools.draftStateCheckedIn"],
    },
    CHECKED_OUT: {
        LABEL: translations.data["venonboard.internalTools.chipStatusCheckout"],
        VALUE: translations.data["venonboard.internalTools.draftStateCheckedOut"],
    },
};
export var HEADER_TABS = {
    OVERVIEW: { LABLE: "Overview", VALUE: "overview" },
    INTERNAL_TOOLS: { LABLE: "Internal Tools", VALUE: "internalTools" },
    YOUR_INDOOR_MAP: { LABLE: "Your Indoor Maps", VALUE: "indoorMap" },
    DOCUMENTATIONS: { LABLE: "Documentation", VALUE: "documentation" },
};
//TODO: hardcoded the value for now as computed value is not allowed in ts v4.9 with v5 we will be able to achieve that
export var GLOBAL_MAP_DETIALS;
(function (GLOBAL_MAP_DETIALS) {
    GLOBAL_MAP_DETIALS["EDIT_MAP"] = "Edit Map";
    GLOBAL_MAP_DETIALS["VIEW_MAP"] = "View map";
})(GLOBAL_MAP_DETIALS || (GLOBAL_MAP_DETIALS = {}));
export var PROMISE_RESPOSE;
(function (PROMISE_RESPOSE) {
    PROMISE_RESPOSE["FULFILLED"] = "fulfilled";
    PROMISE_RESPOSE["REJECTED"] = "rejected";
})(PROMISE_RESPOSE || (PROMISE_RESPOSE = {}));
var UNEmbargoAlpha2Codes = ["CU", "IR", "KP", "SS", "SY"];
export var REGEX_PATTERNS = {
    POSTAL_CODE: /^(?=.*\d.*)([A-Za-z0-9`-]|(\s+)){3,10}$/,
    Z_INDICES: /^([0-9-, ])+$/,
    LATITUDE: /^-?([0-8]?[0-9]|90)(\.[0-9]{1,10})?$/,
    LONGITUDE: /^-?([0-9]{1,2}|1[0-7][0-9]|180)(\.[0-9]{1,10})?$/,
};
export var FORM_FIELD_TEXT = {
    SUBMIT: { LABEL: translations.data["venonboard.button.submit"] },
    CANCEL: { LABEL: translations.data["venonboard.form.cancel"] },
    BACK: { LABEL: translations.data["venonboard.form.back"] },
    NEXT: { LABEL: translations.data["venonboard.form.next"] },
    ORGANIZATION_ID: {
        LABEL: translations.data["venonboard.newMapOrder.organizationId"],
    },
    MAP_NAME: {
        LABEL: translations.data["venonboard.form.name"],
        PLACEHOLDER: translations.data["venonboard.form.name.placeholder"],
    },
    MAP_TYPE: {
        LABEL: translations.data["venonboard.form.mapType"],
        PLACEHOLDER: translations.data["venonboard.form.mapType.placeholder"],
    },
    ADDRESS_1: {
        LABEL: translations.data["venonboard.form.address1"],
        PLACEHOLDER: translations.data["venonboard.form.address1.placeholder"],
    },
    ADDRESS_2: {
        LABEL: translations.data["venonboard.form.address2"],
        PLACEHOLDER: translations.data["venonboard.form.address2.placeholder"],
    },
    CITY: {
        LABEL: translations.data["venonboard.form.city"],
        PLACEHOLDER: translations.data["venonboard.form.city.placeholder"],
    },
    POSTAL_CODE: {
        LABEL: translations.data["venonboard.form.postalCode"],
        PLACEHOLDER: translations.data["venonboard.form.postalCode.placeholder"],
    },
    COUNTRY: {
        LABEL: translations.data["venonboard.form.country.headline"],
        PLACEHOLDER: translations.data["venonboard.form.country.placeholder"],
    },
    LAT: {
        LABEL: translations.data["venonboard.form.coordinates.latitude"],
        PLACEHOLDER: translations.data["venonboard.form.coordinates.latitude.placeholder"],
    },
    LNG: {
        LABEL: translations.data["venonboard.form.coordinates.longitude"],
        PLACEHOLDER: translations.data["venonboard.form.coordinates.longitude.placeholder"],
    },
    DESC: {
        LABEL: translations.data["venonboard.form.descriptionBox.placeholder"],
    },
    TOTAL_AREA: {
        LABEL: translations.data["venonboard.form.venueSize"],
        PLACEHOLDER: translations.data["venonboard.form.venueSize.placeholder"],
    },
    TOTAL_FLOORS: {
        LABEL: translations.data["venonboard.form.levels"],
        PLACEHOLDER: translations.data["venonboard.form.levels.placeholder"],
    },
};
export var ORDER_MAP_3D_VIEWER = translations.data["venonboard.3dOrderMap.3dViewer"];
export var MAP_UUID_LABEL = translations.data["venonboard.MapUUID"];
export var DELETE_CONFIRM_MSG = translations.data["venonboard.deleteConfirm.message"];
export { OVERVIEW_PAGE, JSMAP, INDOOR_MAP, GEOJSON_GEOMETRY_TYPE, MapFields, UNEmbargoAlpha2Codes, };
export var ENVIRONMENT = {
    DEV: {
        DOMAIN: "dev.portal.platform.in.here.com",
        ID: "dev",
    },
    LOCAL: {
        DOMAIN: "pre-sv.portal.platform.in.here.com",
        ID: "dev",
    },
    PRE_SV: {
        DOMAIN: "pre-sv.portal.platform.in.here.com",
        ID: "pre-sv",
    },
    SIT: {
        DOMAIN: "platform.in.here.com",
        ID: "stg",
    },
    PROD: {
        DOMAIN: "platform.here.com",
        ID: "prod",
    },
};
export var NOTIFICATION_VARIANT = {
    INFO: "inverse",
    CONFIRM: "positive",
    ERROR: "error",
    WARN: "warning",
};
export var DRAFT_TYPE = {
    NEW_ORDER: "newOrder",
    UPDATE_ORDER: "updateOrder",
    MIGRATE_ORDER: "migrationOrder",
    UPDATE_DRAFT_ORDER: "updateDraft",
    NEW_DRAFT_ORDER: "newDraft",
};
export var API_STATUS_CODE = {
    SUCCESS: 200,
    BAD_REQUEST: 400,
    INTERNAL_SERVER_ERROR: 500,
    SERVICE_UNAVAILABLE: 503,
    RESOURCE_UNAVAILABLE: 410,
    GATEWAY_TIMEOUT: 504,
    NOT_FOUND: 404,
    DEFAULT: 0,
    REQUEST_ACCEPTED: 202,
};
export var ALLOWED_FILE_TYPES = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/svg+xml",
    "text/plain",
    "text/csv",
    "application/pdf",
    "application/postscript",
];
export var ALLOWED_FILE_EXTENSION = [
    "ai",
    "jpeg",
    "png",
    "gif",
    "csv",
    "pdf",
    "cad",
    "bim",
    "rvt",
    "dwg",
    "svg",
    "txt",
];
export var ACCEPTABLE_FILE_EXTENSION = " .txt, .jpeg, .png, .gif, .svg, .csv, .pdf, .ai, .cad, .bim, .rvt, .dwg";
// realm mapping
export var REALM_MAPPINGS = {
    PRD: "olp-here-indoor",
    PRD_SIT: "org651595200",
    ORG16: "org16291096",
    PRD_INTEGRATION: "olp-here-ci-mp-p",
};
